export const STATUS_MAPPINGS = {
  formatted: 'formatted',
  total: 'all'
} as const;

export const STATUS_COLORS = {
  pending: 'yellow',
  doubtful: 'orange',
  matched: 'red',
  new_hospital: 'blue',
  approved: 'green',
  rejected: 'gray'
} as const;

export const BORDER_COLORS = {
  pending: '#f39c12',
  doubtful: '#e67e22',
  matched: '#e74c3c',
  new_hospital: '#9b59b6',
  approved: '#27ae60',
  rejected: '#95a5a6'
} as const;